import {ApplicationRef, Injectable} from '@angular/core';
import {GraphBoardsListService} from './graphboards-list.service';
import {StateService} from '../../../core/services/state/state.service';
import {Router} from '@angular/router';
import {DeviceDetectorService} from 'ngx-device-detector';
// import {IMyOptions} from 'mydatepicker';
import {ContentSearchFilters} from '../../../shared/classes/services/content_search_filters';
import {IDropdownSettings} from 'ng-multiselect-dropdown';

@Injectable({
    providedIn: 'root'
})
export class GraphBoardsSearchFiltersService extends ContentSearchFilters {

    public preferences: boolean;
    public filter: boolean;

    public datePickerOptions: any = {dateFormat: 'dd/mm/yyyy'};
    public dateStart: any;
    public dateEnd: any;
    public dateStartModel = {};
    public dateEndModel = {};
    public hiringDateModel = {};

    public testsOptions: any;
    public optionsTestsModel: any = [];

    public dropDownSettings: IDropdownSettings = {
        idField: 'id',
        textField: 'name',
        itemsShowLimit: 1,
        enableCheckAll: false
    };

    public subAccountsOptions = [];
    public subAccountsOptionsModel: any = [];

    public departmentOptions = [];
    public departmentOptionsModel: any = [];

    public testStatuses: any = {};
    public optionsTestsStatusModel = [];
    public optionsTestsStatusRaModel = [];

    public testsStatusOptions: any;

    public checkedColumn: any = [];

    public sortCardsBy = '';
    public sortCardsOrder = 'asc';

    constructor(
        public stateService: StateService,
        protected router: Router,
        protected applicationRef: ApplicationRef,
        protected deviceService: DeviceDetectorService,
        protected graphBoardsList: GraphBoardsListService
    ) {
        super(stateService, router, applicationRef, deviceService);
    }

    initInputState() {
        if (this.stateService[this.graphBoardsList.specificState].listSearchFilters) {
            // Sub-accounts
            if (this.stateService[this.graphBoardsList.specificState].listSearchFilters.subAccount) {
                let subAccArr = this.stateService[this.graphBoardsList.specificState].listSearchFilters.subAccount;
                if (typeof this.stateService[this.graphBoardsList.specificState].listSearchFilters.subAccount === 'string') {
                    subAccArr = subAccArr.split(',');
                }
                this.subAccountsOptionsModel = subAccArr
                    .map(function (item) {
                        return parseInt(item, 10);
                    });
            }

            // Departments
            this.setDepartmentsModel(this.stateService[this.graphBoardsList.specificState]);
        }

        let colSelected = 0;
        for (let col of this.columns) {
            if (this.filtering(this.listColumns, col)) {
                colSelected++;
            }
        }
    }

    initInputStatePreferences(obj) {
        if (this.graphBoardsList.userPreferences && this.graphBoardsList.userPreferences.graphboard) {
            for (let col in this.graphBoardsList.userPreferences.graphboard.display) {
                if (this.graphBoardsList.userPreferences.graphboard.display.hasOwnProperty(col)) {
                    let index = 0;
                    for (let o of this.listColumns) {
                        if (o.key === obj.userPreferencesService.plusToDot(col)) {
                            if (this.listColumns[index]) {
                                this.listColumns[index].display = this.graphBoardsList.userPreferences.graphboard.display[col];
                            }
                        } else {
                        }
                        index++;
                    }
                }
            }
        }
        if (this.stateService[this.graphBoardsList.specificState].listSearchFilters) {
            // Sub-accounts
            this.subAccountsOptionsModel = [];
            if (this.stateService[this.graphBoardsList.specificState].listSearchFilters.subAccount) {
                let subAccArr = this.stateService[this.graphBoardsList.specificState].listSearchFilters.subAccount;
                if (typeof this.stateService[this.graphBoardsList.specificState].listSearchFilters.subAccount === 'string') {
                    subAccArr = subAccArr.split(',');
                }

                this.subAccountsOptionsModel = subAccArr
                    .map(function (item) {
                        return parseInt(item, 10);
                    });
            }
            // Departments
            this.setDepartmentsModel(this.stateService[this.graphBoardsList.specificState]);
            if (obj && obj.changeDetectorRef) {
                obj.changeDetectorRef.markForCheck();
            }
        }
    }

    get columns() {
        return this.graphBoardsList.columns;
    }

    get listColumns() {
        return this.graphBoardsList.listColumns;
    }
}
